import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getLiveStreamByMatchid } from '../service/getLiveStreamByMatchid';
import eyewatcher from "../assets/images/eye-watcher.svg";
import getSessionId from '../utils/getSessionId'; // Import getSessionId
import joinMatch from '../actions/joinMatch'; // Import joinMatch
import leaveMatch from '../actions/leaveMatch'; // Import leaveMatch
import fetchViewerCount from '../actions/fetchViewerCount'; // Import fetchViewerCount

const LiveStream = () => {
    const { matchId } = useParams();
    const [liveStreamLink, setLiveStreamLink] = useState(null);
    const [activeUsers, setActiveUsers] = useState(1);

    const apiurl = process.env.REACT_APP_APIURL;

    sessionStorage.setItem("matchId", matchId);
    // Fetch live stream link
    useEffect(() => {
        const fetchLiveStream = async () => {
            try {
                const link = await getLiveStreamByMatchid(matchId);
                setLiveStreamLink(link);
            } catch (error) {
                console.error('Error fetching live stream link:', error);
            }
        };

        fetchLiveStream();
    }, [matchId, apiurl]);

    const sessionId = getSessionId(); // Get session ID using the utility

    // Using joinMatch and leaveMatch from separate files
    const handleJoinMatch = useCallback(() => joinMatch(apiurl, matchId, sessionId), [apiurl, matchId, sessionId]);
    const handleLeaveMatch = useCallback(() => leaveMatch(apiurl, matchId, sessionId), [apiurl, matchId, sessionId]);

    useEffect(() => {
        const updateViewerCount = () => fetchViewerCount(apiurl, matchId, setActiveUsers); // Fetch viewer count

        const intervalId = setInterval(updateViewerCount, 5000);
        handleJoinMatch().then(updateViewerCount);

        return () => {
            clearInterval(intervalId);
           // handleLeaveMatch();
        };
    }, [handleJoinMatch, handleLeaveMatch, apiurl, matchId]);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            handleLeaveMatch();
            event.returnValue = '';
        };

        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                handleLeaveMatch();
            } else if (document.visibilityState === 'visible') {
                handleJoinMatch();
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [handleLeaveMatch, handleJoinMatch]);

   



    const toggleIframeFullScreen = () => {
        const iframe = document.getElementById("iframe");
        const fullscreenButton = document.querySelector(".iconfullscreen");
        const body = document.body;

        if (!iframe) {
            console.error("Iframe not found!");
            return;
        }

        if (iframe.requestFullscreen || iframe.mozRequestFullScreen || iframe.webkitRequestFullscreen || iframe.msRequestFullscreen) {
            if (!document.fullscreenElement) {
                if (iframe.requestFullscreen) {
                    iframe.requestFullscreen();
                } else if (iframe.mozRequestFullScreen) {
                    iframe.mozRequestFullScreen();
                } else if (iframe.webkitRequestFullscreen) {
                    iframe.webkitRequestFullscreen();
                } else if (iframe.msRequestFullscreen) {
                    iframe.msRequestFullscreen();
                }
                fullscreenButton.classList.add('in-fullscreen');
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                }
                fullscreenButton.classList.remove('in-fullscreen');
            }
        } else {
            const isFullScreen = iframe.classList.contains('iframe-fullscreen');
            if (!isFullScreen) {
                iframe.classList.add('iframe-fullscreen');
                body.classList.add('iframe-fullscreen-mode');
                fullscreenButton.classList.add('in-fullscreen');
            } else {
                iframe.classList.remove('iframe-fullscreen');
                body.classList.remove('iframe-fullscreen-mode');
                fullscreenButton.classList.remove('in-fullscreen');
            }
        }
    };

    window.addEventListener("orientationchange", () => {
        const iframe = document.getElementById("playframe");
        if (iframe && document.fullscreenElement) {
            iframe.style.width = window.innerWidth + "px";
            iframe.style.height = window.innerHeight + "px";
        }
    });

    return (
        <div className='container'>
            <a href='/' className='btn-back'>Back</a>
            <div className='video-wrapper'>
                <div className='video-container' id='iframe'>
                    <div className='liveVisit'>
                        <small>LIVE</small>
                        <span><img src={eyewatcher} alt='watchers' /> {activeUsers ? activeUsers : 1}</span>
                    </div>
                    {liveStreamLink ? (
                        <iframe src={liveStreamLink} style={{
                            display: 'block',
                            padding: '0px 0',
                            border: '1px solid #000',
                            backgroundColor: '#000',
                            width: '100%'
                        }} width="720" height="480" title='live stream' id="playframe" allowFullScreen allow='fullscreen'></iframe>
                    ) : (
                        <div className="box-spinner"></div>
                    )}
                    <div onClick={toggleIframeFullScreen} className='fullscreenIcon'>
                        <i className='iconfullscreen'></i>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LiveStream;
